const isValidFormat = (email: string) =>
  email.match(/^\w+([.&-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,15})+$/)
export default { isValidFormat }
